module.exports = __webpack_public_path__ + "static/img/support_menu_title.f2d8fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/img/support-article/support_menu_title.png
// module id = 665
// module chunks = 1